var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechimpactNowords(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71.16,
    height: 70.787,
    viewBox: "0 0 71.16 70.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.33333 0 0 -1.33333 0 70.787)"
  }, /*#__PURE__*/React.createElement("g", {
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    transform: "scale(.1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c1c4c6",
    d: "M143.219 265.449c0-39.551-32.059-71.613-71.61-71.613-39.547 0-71.605 32.062-71.605 71.613 0 39.547 32.059 71.61 71.605 71.61 39.551 0 71.61-32.063 71.61-71.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1c4c6",
    d: "M143.219 71.61C143.219 32.058 111.16 0 71.609 0 32.063 0 .004 32.059.004 71.61c0 39.55 32.059 71.613 71.605 71.613 39.551 0 71.61-32.063 71.61-71.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1c4c6",
    d: "M533.688 265.449c0-39.551-32.059-71.613-71.61-71.613s-71.613 32.062-71.613 71.613c0 39.547 32.062 71.61 71.613 71.61s71.61-32.063 71.61-71.61"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c1c4c6",
    d: "M533.688 71.61c0-39.551-32.059-71.61-71.61-71.61s-71.613 32.059-71.613 71.61c0 39.55 32.062 71.613 71.613 71.613s71.61-32.063 71.61-71.614"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef7d15",
    d: "M143.219 459.285c0-39.551-32.059-71.609-71.61-71.609-39.547 0-71.605 32.058-71.605 71.609 0 39.547 32.059 71.613 71.605 71.613 39.551 0 71.61-32.066 71.61-71.613"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69c32f",
    d: "M533.688 459.285c0-39.551-32.059-71.609-71.61-71.609s-71.613 32.058-71.613 71.609c0 39.547 32.062 71.613 71.613 71.613s71.61-32.066 71.61-71.613"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f59ab",
    d: "M338.453 459.285c0-39.551-32.058-71.609-71.609-71.609-39.551 0-71.614 32.058-71.614 71.609 0 39.547 32.063 71.613 71.614 71.613s71.609-32.066 71.609-71.613"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1f59ab",
    d: "M338.844 263.465c0 40.644-32.059 73.594-71.61 73.594-38.851 0-70.461-31.813-71.558-71.473h-.047V73.594C195.629 32.949 227.688 0 267.234 0c39.551 0 71.61 32.95 71.61 73.594v189.871"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechimpactNowords);
export default __webpack_public_path__ + "static/media/techimpact-nowords.eafaf1f39bfbeb187eb88b42bea0d9be.svg";
export { ForwardRef as ReactComponent };